module.exports = __webpack_public_path__ + "img/lw-open.efa7b4a9.png";